import BackendApiService from "../services/BackendApiService";

class FileHelper{

    static getBase64(file){
        return new Promise((res, rej) =>{
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => res(reader.result);
            reader.onerror = () => rej(reader.error);
        })
    }

    static getFileNameFromUrl(url){
        let name = '';
        if(url){
            name = url.substring(url.lastIndexOf("/") + 1, url.length);
        }
        return name;
    }
    
    static downloadFile = async (fileUrl) => {
        const response = await BackendApiService.downloadFile(fileUrl);
        if (!response.data || !response.data.data) {
            throw new Error('Error at downloading file');
        }

        const buf = Buffer.from(response.data.data);
        const blob = new Blob([buf], {type: 'application/pdf'});
        const objectUrl = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = objectUrl;
        link.download = FileHelper.getFileNameFromUrl(fileUrl) || 'documento.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(objectUrl);
    }

    static allowedExtensions(ext){
        const extensions  = ['image/jpeg', 'image/png', 'application/pdf'];
        return extensions.includes(ext);
    }
}

export default FileHelper;